import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyCyb9VXhDNLmKKAXqh2lDyW8Tqz0eiczqc",
  authDomain: "kljlahirutraders-notifications.firebaseapp.com",
  databaseURL:
    "https://kljlahirutraders-notifications-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "kljlahirutraders-notifications",
  storageBucket: "kljlahirutraders-notifications.firebasestorage.app",
  messagingSenderId: "888367896954",
  appId: "1:888367896954:web:004e5bf078469eab615ec3",
  measurementId: "G-MEF7SN2RGY",
};

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

export { app, database };
